'use client'

import { useRollbar } from '@rollbar/react'
import { useEffect } from 'react'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const rollbar = useRollbar()

  useEffect(() => {
    rollbar.error(error)
  }, [error, rollbar])

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      <h2 className="text-xl font-semibold">Something went wrong</h2>
      <button
        type="button"
        onClick={reset}
        className="rounded bg-primary px-4 py-2 text-sm text-primary-foreground"
      >
        Try again
      </button>
    </div>
  )
}
